/**
 * Token amount formatting utilities.
 * Extracted from WalletController for use without ControllerFactory.
 */
import { TokenAmountConverter } from "domain/wallet/controllers/utils/TokenAmountConverter";

export function formatTokenAmount(bigToken: string, decimals: number): string {
    return TokenAmountConverter.formatToken(bigToken, decimals);
}

export function parseTokenAmount(token: string, decimals: number): string {
    return TokenAmountConverter.parseToken(token, decimals);
}
